module.exports = __webpack_public_path__ + "media/images/admin2/Select-ab094cd5952c4565266820e7cd5edd63.svg";